export default "__VITE_ASSET__C$EQBmm3__"